import ajax from 'utils/request';

// 获取appkey列表
export function getAppkeys(params) {
    return ajax('GET', '/accounts/my/apikeys', params);
}
// 查看appkey
export function getAppkey(id) {
    return ajax('GET', `/apikeys/${id}`);
}



// WEBPACK FOOTER //
// ./src/actions/appkey.js